<template>
    <div id="app">
        <v-app id="inspire">   
            <v-layout>
                <v-container>
                    <v-flex xs6 right>
                        <v-text-field dark solo flat hide-details label="Search" v-model="search" append-icon="search" color="deep-orange" clearable></v-text-field>
                    </v-flex>
                </v-container>
            </v-layout>

            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 lg4>
                    <v-menu v-model="dateFrom" :close-on-content-click="false" full-width max-width="290">
                        <template v-slot:activator="{ on }">
                            <v-text-field :value="computedDateFormattedMomentjsFrom" label="Date From" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" :max="new Date().toISOString().substr(0, 10)" @change="dateFrom = false"></v-date-picker>
                    </v-menu>
                    </v-flex>
                    
                    <v-flex xs12 lg4>
                    <v-menu v-model="dateTo" :close-on-content-click="false" full-width max-width="290">
                        <template v-slot:activator="{ on }">
                            <v-text-field :value="computedDateFormattedMomentjsTo" label="Date To" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" @change="dateTo = false" :min="date1"></v-date-picker>
                    </v-menu>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex>
                        <v-btn outline color="indigo" @click="exportDialog=true">Export Report</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout>
                <v-flex xs12>
                    <v-data-table :search="search" :headers="headers" :items="branchTransactions" class="elevation-1">
                        <template v-slot:items="props">
         
                            <td>{{ props.item.transactionId }}</td>
                            <td class="text-xs-left">{{ props.item.customerType }}</td>
                            <td class="text-xs-left">{{ props.item.appointmentDate }}</td>
                            <td class="text-xs-left">{{ props.item.appointmentTime }}</td>
                            <td class="text-xs-left">{{ props.item.customerName }}</td>
                            <td class="text-xs-left"> <div v-for="(service,index) in props.item.initialService" :key="index">{{service.service }} </div>
                            <div v-for="(service,index) in props.item.otherService" :key="index">{{service.service }} </div>
                             </td>
                            <td class="text-xs-left">{{ props.item.estimateCharge }}</td>
                            <td class="text-xs-left">{{ props.item.tag }}</td>
                        
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Data Available
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                </v-flex>
            </v-layout> 

            </v-container> 

            <v-dialog v-model="exportDialog" max-width="500px">
                <v-card>
                    <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                    <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to export this transactions? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to download all transactions from selected date range and it will saved as CSV file.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="exportDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4"  @click="(exportDialog=false),exportRequests()">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                    
                </v-card>
                
            </v-dialog>

            <v-dialog v-model="dialog" persistent width="300">
                <v-card  color="primary">
                    <v-card-text class="subheading white--text"> {{progressMessage}}
                        <v-layout row justify-center>
                        <v-progress-linear :indeterminate="true" v-if="showProgress"
                            :size="70"
                            :width="5"
                            color="white"
                        ></v-progress-linear>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-snackbar class="subheading" v-model="snackbar" top vertical :color="snackbarColor">{{ snackbarMessage }} 
                <v-btn dark  flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>

        
        </v-app>
    </div>    
</template>


<script>
import store from '../stores'
import firebase from "firebase";
import {db} from '../main';
import { mapGetters, mapState } from "vuex";
import moment from 'moment';
const { Parser } = require('json2csv');
import converter from "json-2-csv";
import { stage } from '../../appConfig'
export default {
    data: () => ({
        exportDialog: false,
        dialog: false,
        showProgress: false,
        progressMessage: "",
        snackbarMessage: "",
        snackbarColor: "primary",
        snackbar: false,
        date1: moment().utcOffset('+0800').toISOString().substr(0, 10),
        date2: moment().utcOffset('+0800').toISOString().substr(0, 10),
        dateFrom: false,
        dateTo: false,
        headers: [
            { text: 'Transaction#', align: 'left', sortable: true, value: 'transactionId'},
            { text: 'Type', value: 'customerType',  sortable: false  },
            { text: 'Date', value: 'appointmentDate',  sortable: true  },
            { text: 'Time', value: 'appointmentTime',  sortable: false  },
            { text: 'Name', value: 'customerName',  sortable: false  },
            { text: 'Services', value: 'initialService',  sortable: false  },
            { text: 'Labor Charge', value: 'estimateCharge',  sortable: false  },
            { text: 'Tag', value: 'tag', sortable: false }
        ],
        search: "",
        lists: [],
        branchTransactions: [],
        formattedTransactions: [],

    }),

    methods : {
        async fetchTransactions() {
            let self = this;
            self.dialog = true
            self.showProgress = true
            self.progressMessage = "Loading Data.."
            self.lists = []
            self.branchTransactions = []
            self.formattedTransactions = []
            await db.collection("ServiceBooking"+self.$stage).get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.lists.push(doc.data())
                    if(self.user.assign == doc.data().branch) {
                        if (self.date1 <= doc.data().appointmentDate &&  self.date2 >= doc.data().appointmentDate) {
                            self.branchTransactions.push(doc.data())
                            var services = []
                            for (var i = 0; i < doc.data().initialService.length; i++) { 
                                services.push(doc.data().initialService[i].service)
                            }
                            self.formattedTransactions.push({
                                "Control Number": doc.data().transactionId,
                                "Customer": doc.data().customerName,
                                "E-mail": doc.data().customerEmail,
                                "Mobile Number": doc.data().mobileNumber,
                                "Services":services,
                                "Other Service": doc.data().otherService,
                                "Labor Charge": doc.data().estimateCharge,
                                "Date": doc.data().appointmentDate,
                                "Time": doc.data().appointmentTime,
                                "Customer Type": doc.data().customerType,
                                "Status": doc.data().status,
                                "Tag": doc.data().tag,
                            })
                        }
                    }
                })
            }).then(function() {
                self.dialog = false
                self.showProgress = false
            })
        },

        exportRequests() {
            let self = this;

            downloadCSV({ filename: "export.csv", data: self.formattedTransactions });

            function convertArrayOfObjectsToCSV(args) {  
                var result, ctr, keys, columnDelimiter, lineDelimiter, data;

                data = args.data || null;
                if (data == null || !data.length) {
                    return null;
                }

                columnDelimiter = args.columnDelimiter || '\t';
                lineDelimiter = args.lineDelimiter || '\n';

                keys = Object.keys(data[0]);

                result = '';
                result += keys.join(columnDelimiter);
                result += lineDelimiter;

                data.forEach(function(item) {
                    ctr = 0;
                    keys.forEach(function(key) {
                        if (ctr > 0) result += columnDelimiter;

                        result += item[key];
                        ctr++;
                    });
                    result += lineDelimiter;
                });

                return result;
            }

            function downloadCSV(args) {  
                var data, filename, link;
                var csv = convertArrayOfObjectsToCSV({
                    data: args.data
                });
                if (csv == null) return;

                filename = args.filename || 'export.csv';

                if (!csv.match(/^data:text\/csv/i)) {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                }
                data = encodeURI(csv);

                link = document.createElement('a');
                link.setAttribute('href', data);
                link.setAttribute('download', filename);
                link.click();
            }
        }
    },

    mounted() {
        let self = this
        self.fetchTransactions()
    },

    computed: {
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),

        computedDateFormattedMomentjsFrom () {
            return this.date1 ? moment(this.date1).format('dddd, MMMM Do YYYY') : ''
        },
        computedDateFormattedMomentjsTo () {
            return this.date2 ? moment(this.date2).format('dddd, MMMM Do YYYY') : ''
        },
    },

    watch: {
        date1(val) {
            if(this.date1 > this.date2){
                this.date2 = ""
            }

            if(this.date1 != "" && this.date2 != "") {
                this.fetchTransactions()
            }
        },

        date2(val) {
            if(this.date1 != "" && this.date2 != "") {
                this.fetchTransactions()
            }  
        }
    },
    
}
</script>

<style scoped>

</style>
